module.exports = __webpack_public_path__ + "assets/5ffe25a16d09e7b80bc0204610985753.svg";